module.exports = __webpack_public_path__ + "images/category_lp/pc/footer_img_c95dd486d3a64c4a72563e32f3d976d9.jpg";